import { Injectable } from "@angular/core";
import { NamedType } from "../model/domain/Tipo";
import {
  Currency,
  OperationType,
  EntryType,
  AssetCode,
} from "../model/domain/Entity";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";
import { CurrencyTerm } from "../model/domain/CurrencyTerm";
import { IDataResult } from "../model/OperationResult";
import {
  RepositoryService,
  IRepositoryService,
} from "./seedwork/IRepositoryService";

@Injectable({
  providedIn: "root",
})
export class TermoMoedaService extends RepositoryService<CurrencyTerm> {
  constructor(private http: HttpClient) {
    super();
  }
  public getUrl(p: string = ""): string {
    return `${environment.apiUrls.tickets}/currency-term/` + p;
  }
  public GetHttp() {
    return this.http;
  }

  ListarTipoOperacaoTermoMoeda(): NamedType<number>[] {
    return [
      NamedType.Create(OperationType.PurchasedCurrency, "Moeda Comprada"),
      NamedType.Create(OperationType.SoldCurrency, "Moeda Vendida"),
    ];
  }

  ListarMoedas(): NamedType<number>[] {
    return [
      NamedType.Create(Currency.USD, "Dólar"),
      NamedType.Create(Currency.EUR, "Euro"),
      NamedType.Create(Currency.JPY, "Yene"),
    ];
  }

  public ListaCotacaoVencimento(): NamedType<number>[] {
    return [
      NamedType.Create(1, "PTAX D-1"),
      NamedType.Create(2, "PTAX D-2"),
      NamedType.Create(3, "PTAX D-3"),
      NamedType.Create(4, "PTAX D-4"),
      NamedType.Create(5, "PTAX D-5"),
    ];
  }

  ListarTiposLancamento(): NamedType<number>[] {
    return [
      NamedType.Create(EntryType.Register, "Registro"),
      NamedType.Create(EntryType.EarlySettlement, "Liquidação Antecipada"),
    ];
  }
}
